import * as Actions from '../../actions/fuse';

const initialState = {
	isLoaderShow: false
};

const LoaderReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.IS_LOADER: {
			return { ...state, ...initialState, isLoaderShow: action.payload };
		}
		default:
			return { ...state };
	}
};
export default LoaderReducer;
